import { Model } from 'core/models';

export class LdapConfiguration extends Model {
    public id?: number;
    public _PATH?: string;
    public _ADMIN_USERNAME?: string;
    public _ADMIN_PASSWORD?: string;
    public _BASE_DN?: string;

}
